export * from './src/locations-v1-location-locations.universal.js';
